import cn from "classnames";
import { nanoid } from "nanoid";
import { FC } from "react";

import s from "./index.module.css";
import Select from "@UI/Select";

interface DurationType {
  type: "minute" | "hour" | "month";
  value: number;
}

const createFakeHistory = (
  date: string,
  sourceName: string,
  classTitle: string,
  duration: DurationType,
  sum: number,
  currency: string,
  old_date: string,
  new_date: string,
) => ({ id: nanoid(), date, sourceName, classTitle, duration, sum, currency, old_date, new_date });


export type ItemType = ReturnType<typeof createFakeHistory>;

interface TablePaymentsDiscountsProps {
  items?: ItemType[];
  className?: string;
}

const resolveCurrency = (currency:string) => {
    switch (currency) {
        case 'euro':
            return '€'
        case 'dollar':
            return '$'
        case 'rub':
        default:
            return '₽'
    }
}

const resolveSum = (items:any) => {
    let sumRub:number = 0;
    let sumEuro:number = 0;
    let sumDollar:number = 0;

    items.forEach((item:any) => {
        if (item.currency.toLowerCase() === 'rub') {
          sumRub += Math.round(Number(item.sum));
        } else if (item.currency.toLowerCase() === 'euro') {
          sumEuro += Number(item.sum);
        } else {
          sumDollar += Number(item.sum);
        }
    })

  return [
      Number(sumRub).toFixed(0) + resolveCurrency('rub'),
      Number(sumEuro).toFixed(2) + resolveCurrency('euro'),
      Number(sumDollar).toFixed(2) + resolveCurrency('dollar')];
}

const resolveType = (type: string) => (
    type === 'hour' ? 'ч.'
        : type === 'minute' ? 'мин.'
            : type === 'month' ? 'мес.'
                : type === 'enrollment' ? 'занятие'
                    : ''
);
export const TablePaymentsDiscounts: FC<TablePaymentsDiscountsProps> = ({
  items,
  className,
}) => {
  let sum = resolveSum(items);
  
  return (
    <div className={cn(className, s.tableWrapper, 'customScroll')}>
      {/* <Select className={s.courses} options={[{value: 0, label: "Все курсы"}]} /> */}

      <table className={s.table}>
        <thead>
        <tr>
            <td className={cn(s.card, s.cardHead, 'backgroundNewGrey')}>Дата</td>
            <td className={cn(s.card, s.cardHead, 'backgroundNewGrey')}>Класс</td>
            <td className={cn(s.card, s.cardHead, 'backgroundNewGrey')}>Направление</td>
            <td className={cn(s.card, s.cardHead, 'backgroundNewGrey')}>Длительность</td>
            <td className={cn(s.card, s.cardHead, 'backgroundNewGrey')}>Оплачено с</td>
            <td className={cn(s.card, s.cardHead, 'backgroundNewGrey')}>Оплачено до</td>
            <td className={cn(s.card, s.cardHead, 'backgroundNewGrey')}>Сумма</td>
            <td className={cn(s.card, s.cardHead, 'backgroundNewGrey')}>Валюта</td>
        </tr>
        </thead>
          <tbody>
          {items?.map((item) => (
              <tr key={item.id}>
                  <td className={cn(s.card, s.cardBody, 'backgroundNone')}>{item.date}</td>
                  <td className={cn(s.card, s.cardBody, 'backgroundNone')}>{item.classTitle}</td>
                  <td className={cn(s.card, s.cardBody, 'backgroundNone')}>{item.sourceName}</td>
                  <td className={cn(s.card, s.cardBody, 'backgroundNone')}>{item.duration.value + ' ' + resolveType(item.duration.type)}</td>
                  <td className={cn(s.card, s.cardBody, 'backgroundNone')}>{item.old_date ?? ''}</td>
                  <td className={cn(s.card, s.cardBody, 'backgroundNone')}>{item.new_date ?? ''}</td>
                  <td className={cn(s.card, s.cardBody, 'backgroundNone', {[s.red]: item.sum < 0})}>
                      {item.currency === 'rub' ? Number(item.sum).toFixed(0) : Number(item.sum).toFixed(2)}
                  </td>
                  <td className={cn(s.card, s.cardBody, 'backgroundNone')}>{resolveCurrency(item.currency)}</td>
              </tr>
          ))}
          <tr>
              <td></td>
              <td></td>
            <td className={cn(s.card, s.summary, 'backgroundNone backgroundNewYellow')}>ИТОГО</td>
            <td className={cn(s.card, s.summary, 'backgroundNone backgroundNewYellow')}>{sum[0] + ', ' + sum[1] + ', ' + sum[2]}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
